import React from "react";
import TalkData from "./TalkData/TalkData";

function MarketTalks() {
    return(
        <>
            <TalkData />
        </>
    )
}

export default MarketTalks;